<div class="my-2">

    <!-- <button class="mr-2" mat-stroked-button color="primary" (click)="createTransaction()"
        [disabled]="!canCreateTransaction">
        <mat-icon>add</mat-icon> {{ 'TRANSACTIONS.CREATE_TRANSACTION' | transloco }}
    </button> -->

    <button class="mr-2" mat-stroked-button color="primary" (click)="addOrderAdditionalService()" [disabled]="!canCreateTransaction">
        <mat-icon>add</mat-icon>
        {{ 'TRANSACTIONS.CREATE_TRANSACTION' | transloco }}
    </button>

    <!--
      <mat-form-field appearance="outline">
        <mat-label>Sök</mat-label>
        <input matInput (keyup)="applyFilter($event)"
          placeholder="Sök på Description eller Log..." #input>
      </mat-form-field>
    -->
    <mat-paginator [pageSizeOptions]="[100, 150, 250]" showFirstLastButtons></mat-paginator>
    <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="transactionNr">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Nr</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.transactionNr }} </td>
        </ng-container>

        <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.amount }}</td>
        </ng-container>

        <ng-container matColumnDef="vatAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vat Amount</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.vatAmount }}</td>
        </ng-container>

        <ng-container matColumnDef="amountIncVat">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Amount</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.amountIncVat }}</td>
        </ng-container>

        <ng-container matColumnDef="remainingReversalAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Captured</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.remainingReversalAmount }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Status</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.paymentStatus }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Type</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.paymentType }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Date</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.paymentDate | date: 'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="debitCreditType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Debit Type</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.debitCreditType }}</td>
        </ng-container>

        <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
            <td mat-cell *matCellDef="let transaction"> {{ transaction.created | date: 'yyyy-MM-dd HH:mm' }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let transaction; columns: displayedColumns;" (click)="transactionDetails(transaction)"
            class="clickable">
        </tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">Ingen matchning på "{{input.value}}"...</td>
        </tr>

    </table>

</div>
